import React from 'react'

import { object, string } from 'prop-types'

import CategoryColumn from './Components/CategoryColumn/CategoryColumn'

function CategoriesSection({ byCategory, title }) {
  return (
    <div className="assets-3d-categories__column assets-3d-categories__column--categories">
      <h4 className="assets-3d-categories__title">{title}</h4>
      <div className="assets-3d-categories__categories-list">
        <CategoryColumn items={byCategory.column1} columnKey="col1" />
        <CategoryColumn items={byCategory.column2} columnKey="col2" />
      </div>
    </div>
  )
}

CategoriesSection.propTypes = {
  byCategory: object.isRequired,
  title: string.isRequired,
}

export default CategoriesSection
